//Только для подключения внешних сервисов, Сервисы расположенные в паке views подключаться автоматически
export const services  = [
                          require('@/services/auth-service').default,
                          require('@/services/user-service').default
                         ]
